
import React, { ReactNode, useState } from 'react';
import axios from 'axios';
// @ts-ignore: allow importing CSS without a type declaration
import '../Tracking/PacifixTracking.css';
// import Logo from '../Logo/Jaimarutilogo.png';
import ttslogo from '../Logo/Airkinglogo.png';
import Swal from "sweetalert2";
import TrackingResult from './TrackingResult';
<link
    rel="stylesheet"
    href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css"
/>

interface StatusEntry {
    Destination_name: string;
    LocationName: string;
    Status: string;
    DelvDt: string;
    DelvTime: string;
}
interface TrackingRecord {
    [x: string]: any;
    DocketNo: string;
    BookDate: string;
    DelvDT: string;
    ExptDateOfDelvDt: string;
    OriginCity: string;
    DestinationCity: string;
    ReceiveredPincode: string;
    Consignee_Name: string;
    Status: string;
    DelvTime: string | null;
    VendorAwbNo: string;

    ActualWt: number;
    ChargedWt: number;
    Qty: number;

    EwayBill: string;
    InvoiceNo: string;

    Mode_Code: string;

    Consignee_Mob: string;
    Consignee_Pin: string;

    RecvName: string | null;
    ReceivedMo: string;
    Recvremark: string | null;

    DrsDate: string | null;
    DrsNo: string | null;

    Employee_code: string | null;
    Employee_Mobile: string | null;

    Area: string | null;
    VehicleNo: string | null;

    Location_Code: string | null;

    Manifest_No: string | null;
    Manifest_Dt: string | null;

    From_Dest: string | null;
    ManifestDestination: string | null;

    ImageLink?: string;      // 👈 yahan add karo

    StatusEntry: StatusEntry[];



}

const AirKingTracking = (): JSX.Element => {
    const [searchValue, setSearchValue] = useState('');
    const [trackingData, setTrackingData] = useState<TrackingRecord | null>(null);
    const [showImage, setShowImage] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [error, setError] = useState('');

    const handleButtonClick = () => {
        setShowImage(!showImage);
    };

const fetchData = async () => {
    try {
        if (searchValue.trim() === '') {
            setError('Please enter one or more tracking numbers separated by commas.');
            return;
        }

        const CNoteNo = searchValue.split(',').map(awb => awb.trim());

        const res = await axios.post(
            'https://airkingexpress.net/AirkingexpressAPI/getTrackingData',
            { CNoteNo }
        );

        const data = res.data;

        console.log(data, "Response from API");

        if (data.status === 1 && data.Data) {

            const updatedData = data.Data.map((item: TrackingRecord) => {
                const imageId = item?.CNoteNo;

                return {
                    ...item,
                    ImageLink: `https://airkingexpress.net/portalapi/PODIMAGE/${imageId}.jpg`
                };
            });

            setTrackingData({
                ...data,
                Data: updatedData
            });

            setError('');

            // Clear Input After Successful Search
            setSearchValue('');

        } else {
            setError('Docket Not Found');
        }

    } catch (error) {
        console.error('Error:', error);
        setError('Failed to fetch data. Please check your internet connection.');
    }
};

 
    return (

        <>

            <header className="navbarheader-fluid">

                {/* TOP BAR */}
                <div className="top-bar">
                    Welcome to Air king Express Cargo | Email: airkingexpress@gmail.com Contact No: 9322033242/9323236687
                </div>

                {/* DESKTOP NAVBAR */}
                <div className="navbar-container d-none d-lg-flex">

                    <div className="navbar-logo">
                        <img src={ttslogo} alt="logo" />
                    </div>

                    <nav className="navbar-links">
                        <a href="https://airkingexpress.net/">Home</a>
                        <a href="https://airkingexpress.net/Aboutus.html">About Us</a>
                        <a href="https://airkingexpress.net/Services.html">Services</a>
                        <a href="#">Branch Login</a>
                        <a href="https://airkingexpress.net/Document.html">Document</a>
                        <a href="https://airkingexpress.net/Contact.html">Contact</a>
                    </nav>

                </div>

                {/* MOBILE NAVBAR */}
                <nav className="navbar bg-light fixed-top d-lg-none">
                    <div className="container-fluid">

                        {/* MENU BUTTON */}
                        <button
                            className="navbar-toggler"
                            type="button"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasNavbar"
                        >
                            <span className="navbar-toggler-icon"></span>
                        </button>

                        {/* LOGO */}
                        <a className="navbar-brand ms-auto" href="#">
                            <img src={ttslogo} alt="logo" />
                        </a>

                        {/* SIDEBAR MENU */}
                        <div className="offcanvas offcanvas-start" id="offcanvasNavbar">
                            <div className="offcanvas-header">
                                <h5>Menu</h5>
                                <button className="btn-close" data-bs-dismiss="offcanvas"></button>
                            </div>

                            <div className="offcanvas-body">
                                <ul className="navbar-nav">

                                    <li><a href="https://ttscourier.in/">Home</a></li>
                                    <li><a href="#">About Us</a></li>
                                    <li><a href="#">Services</a></li>
                                    <li><a href="https://ttscourier.in/NewLogin/#/login">Branch Login</a></li>
                                    <li><a href="#">Document</a></li>
                                    <li><a href="https://ttscourier.in/NewLogin/#/login">Contact</a></li>

                                </ul>
                            </div>
                        </div>

                    </div>
                </nav>

            </header>
            <div className="tracking-container">
                <div className="tracking-wrapper">

                    <div className="tracking-card">

                        <h2 className="title">
                            Track a Shipment <span className="truck-icon">🚚</span>
                        </h2>

                        <div className="tracking-row">

                            <div className="input-box">
                                <input
                                    type="text"
                                    value={searchValue}
                                    onChange={(e) => setSearchValue(e.target.value)}
                                    placeholder="Enter AWB Number"
                                />
                            </div>

                            <div className="btn-group">

                                <button
                                    className="track-btn"
                                    onClick={fetchData}
                                >
                                    Track Shipment
                                </button>

                                <button
                                    className="clear-btn"
                                    onClick={() => setSearchValue("")}
                                >
                                    Clear
                                </button>

                            </div>

                        </div>

                    </div>

                </div>



                {error && <p className="error">{error}</p>}

                {trackingData && (
                    <TrackingResult trackingData={trackingData} />
                )}

                {/* FOOTER */}
                <footer className="footer-light">
                    <div className="footer-container-fluid">

                        <div className="footer-grid">

                            {/* COLUMN 1 */}
                            <div className="footer-box">
                                <h3>AIR KING EXPRESS</h3>

                                <h4>Mumbai (Head Office)</h4>
                                <p>
                                    We are committed and dedicated
                                    in fulfilling our obligation to our
                                    valued customer by offering
                                    quality services that meets all
                                    the demands and day to day
                                    requirements of our clients,which
                                    makes us a reputed courier and
                                    cargo company in India
                                </p>
                            </div>

                            {/* COLUMN 2 */}
                            <div className="footer-box">
                                <h3> AIR KING EXPRESS </h3>

                                <h4>MUMBAI (Office)</h4>
                                <i className="fa-solid fa-location-dot"></i>
                                <p>
                                    6/10, New Municipal Colony,
                                    Behind Subha Galaxy Hotel,
                                    N.S. Phadke Road, Teli Gali,
                                    Andheri (East), Mumbai,
                                    Maharashtra <br /> Pin Code - 400069
                                </p>

                                <p>📞 +91 7738236687</p>
                                <p>📞 +91 9223507879 </p>

                                <p>✉ airkingexpress@gmail.com</p>
                            </div>

                            {/* COLUMN 3 */}
                            <div className="footer-box">
                                <h3>SERVICES</h3>
                                <ul className="services-list">
                                    <li>Express Courier</li>
                                    <li>E-Commerce</li>
                                    <li>General Cargo</li>
                                    <li>Nominated Shipments</li>
                                    <li>Airline Consolidation</li>
                                    <li>Door to Door Cargo</li>
                                    <li>Dangerous Goods</li>
                                    <li>Cross Border Business</li>
                                    <li>Custom Brokerage</li>
                                </ul>
                            </div>

                            {/* ✅ NEW COLUMN 4 */}
                            <div className="footer-box">
                                <h3>QUICK LINKS</h3>
                                <ul className="services-list">
                                    <li>Home</li>
                                    <li>About Us</li>
                                    <li>Tracking</li>
                                    <li>Contact</li>
                                    <li>Privacy Policy</li>
                                    <li>Standard Conditions of Carriage</li>
                                    <li>Payment Terms and Conditions</li>                                    
                                    <li>Food Items</li>
                                  

                                </ul>
                            </div>

                        </div>

                    </div>
                </footer>
                <div className="footer-bottom">
                    <div className="footer-bottom-container">

                        <div className="footer-left">
                            © Copyright © Air King express All rights reserved.
                        </div>

                        <div className="footer-right">
                            <a href="#">Privacy & Policy</a>
                            <a href="#">Terms and Conditions</a>
                        </div>

                    </div>
                </div>

            </div>
        </>





    );
};

export default AirKingTracking;